import React, { useState } from 'react';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import MuiTooltip, { TooltipProps as MuiTooltipProps } from '@material-ui/core/Tooltip';

const arrowGenerator = () => ({
  '&[x-placement*="bottom"] $arrow': {
    top: 0,
    left: 0,
    marginTop: '-0.9em',
    width: '3em',
    height: '1em',
    '&::before': {
      borderWidth: '0 1em 1em 1em',
      borderColor: 'transparent transparent var(--background-color) transparent',
    },
  },
  '&[x-placement*="top"] $arrow': {
    bottom: 0,
    left: 0,
    marginBottom: '-0.9em',
    width: '3em',
    height: '1em',
    '&::before': {
      borderWidth: '1em 1em 0 1em',
      borderColor: 'var(--background-color) transparent transparent transparent',
    },
  },
  '&[x-placement*="right"] $arrow': {
    left: 0,
    marginLeft: '-0.9em',
    height: '3em',
    width: '1em',
    '&::before': {
      borderWidth: '1em 1em 1em 0',
      borderColor: 'transparent var(--background-color) transparent transparent',
    },
  },
  '&[x-placement*="left"] $arrow': {
    right: 0,
    marginRight: '-0.9em',
    height: '3em',
    width: '1em',
    '&::before': {
      borderWidth: '1em 0 1em 1em',
      borderColor: 'transparent transparent transparent var(--background-color)',
    },
  },
});

const styles = ({
  custom: {
    palette: { colorSupportSteel },
  },
}: Theme) =>
  createStyles({
    arrow: {
      position: 'absolute',
      width: '3em',
      height: '3em',
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: 0,
        height: 0,
        borderStyle: 'solid',
      },
    },
    popper: {
      '--background-color': colorSupportSteel,
      opacity: 1,
      ...arrowGenerator(),
    },
    tooltip: {
      fontSize: 11,
      backgroundColor: colorSupportSteel,
    },
  });

export interface TooltipProps extends Omit<MuiTooltipProps, 'classes'>, WithStyles<typeof styles> {
  hideArrow?: boolean;
  wordBreak?: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({ classes, hideArrow, wordBreak, title, ...rest }) => {
  const [arrowRef, setArrowRef] = useState<any>();

  return (
    <MuiTooltip
      title={
        title && (
          <>
            {title}
            {!hideArrow && <span className={classes.arrow} ref={(ref) => setArrowRef(ref)} />}
          </>
        )
      }
      classes={{
        tooltip: classes.tooltip,
        popper: classes.popper,
      }}
      PopperProps={{
        style: wordBreak && { wordBreak: 'break-all' },
        popperOptions: {
          modifiers: {
            arrow: {
              enabled: Boolean(arrowRef),
              element: arrowRef,
            },
          },
        },
      }}
      {...rest}
    />
  );
};

export default withStyles(styles)(Tooltip);
